import { AlertService } from './../../shared/services/alert.service';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { Injectable } from '@angular/core';

// ID-6B: the registration, verification and password dialogs went with their screens; those live at Pro Pool ID now.
@Injectable()
export class UserDialogService extends AlertService {

	constructor(alertCtrl: AlertController, navCtrl: NavController, modalCtrl: ModalController) {
		super(alertCtrl, navCtrl, modalCtrl);
	}
}
